import { render, staticRenderFns } from "./Mailbox.vue?vue&type=template&id=4ea1cb0d&scoped=true"
import script from "./Mailbox.vue?vue&type=script&lang=js"
export * from "./Mailbox.vue?vue&type=script&lang=js"
import style0 from "./Mailbox.vue?vue&type=style&index=0&id=4ea1cb0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea1cb0d",
  null
  
)

export default component.exports